import { SEGMENT_TRACK, UpdateOrDeleteResponseBody } from "../utils/constant";
import { postJson } from "../utils/network";

export const sendSegmentEvent = async (
  id: string,
  event: string,
  data: any,
  includeUTMs?: boolean,
  traits?: any
) => {
  const { response } = await postJson<UpdateOrDeleteResponseBody>(SEGMENT_TRACK, {
    id,
    event,
    data,
    includeUTMs: includeUTMs === true ? true : undefined,
    traits,
  });

  return response;
};